import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';

function FullScreenComponent({ children }) {
  const ref = useRef();

  useEffect(() => {
    const prevWidth = ref.current.width;
    ref.current.width = window.innerWidth;
    ref.current.height *= window.innerWidth / prevWidth;
    ref.current.x = window.innerWidth / 2;
    ref.current.y = window.innerHeight / 2;
  }, []);

  return (
    <Container name='FullScreenContainer' ref={ref}>
      {children}
    </Container>
  );
}
export default FullScreenComponent;
